export default {
  setACode(state, data) {
    state.aCode = data
  }
}
